import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const Times = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => {}}
      style={style}
      width={width ? width : 12}
      height={height ? height : 12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.273 6l3.846-3.846.793-.793a.3.3 0 0 0 0-.424l-.848-.849a.3.3 0 0 0-.425 0L6 4.728 1.36.087a.3.3 0 0 0-.423 0l-.85.848a.3.3 0 0 0 0 .425L4.728 6l-4.64 4.638a.3.3 0 0 0 0 .425l.85.848a.3.3 0 0 0 .424 0L6 7.273l3.845 3.846.793.793a.3.3 0 0 0 .425 0l.848-.848a.3.3 0 0 0 0-.425L7.273 6z"
        fill={color ? color : neutral[600]}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default Times;
